export const NotFound = () => {
  return <div className="notfound">404 - Página no encontrada :(</div>;
};
